import { Input, Output, EventEmitter, Component, OnInit } from '@angular/core';

import { ViewService } from "app/Services/view.service";
import { TranslationService } from 'app/Services/translation.service';
import { Product } from '../../../Model/Catalog/Product';
import { CatalogService } from '../../../Services/CatalogManagement/catalog.service';
import { ModelService } from '../../../Services/model.service';
import { UserManagementService } from '../../../Services/userManagment.service';
import { ValidationService } from '../../../Services/Validation/validation.service';
import { ProductLogistic } from '../../../Model/Catalog/ProductLogistic';
import { OrderDetail } from '../../../Model/Catalog/OrderDetail';


@Component({
  selector: 'logistic',
  templateUrl: 'logistic.component.html',
  styleUrls: ['./logistic.component.css', '../template.css']
})
export class Logistic implements OnInit {
  @Input() model: Product = new Product();
  @Input() showLinkButtons: Boolean = false;

  @Output() onValueChanged = new EventEmitter<any>();

  @Input() templateView: Boolean = false;
  @Input() selectedElements: string[] = [''];
  @Output() elementSelected = new EventEmitter<string>();

  @Input() showDragHandle: boolean = false;
  @Input() dragFilter: string = 'noDrag';

  @Output() excelElementDropped = new EventEmitter<any>();

  get zero() {
    return ViewService.dropDownZero;
  }

  constructor(
    public modelService: ModelService,
    public validationService: ValidationService,
    public userManagement: UserManagementService,
    public catalogService: CatalogService,
    public translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.model.productLogistic ??= new ProductLogistic();
    this.model.packings ??= [];
    this.model.orderDetail ??= new OrderDetail();
   
  }

  isVirtualCatalog(): boolean {
    return this.catalogService?.catalog?.isVirtual;
  }

  updateFromAutocomplete(event = null, field?: string, system: string = '-1', element: string = '-1') {
    if (!event) event = {};
    if (!event.event) event.event = {};

    // für den template editor erforderlich:
    if (event) {
      event.dField = field;
      event.dSystem = system;
      event.dElement = element;
      event.createTemplateItem = true;

      event.value = event.selectedItem; // value ist in diesem fall nicht gesetzt, darauf baut aber der template editor
    }

    this.onValueChanged.emit(event);
  }

  update(event = null, field?: string, system: string = '-1', element: string = '-1') {
    // für den template editor erforderlich:
    if (event) {
      event.dField = field;
      event.dSystem = system;
      event.dElement = element;
      event.createTemplateItem = true;
    }

    this.onValueChanged.emit(event);
  }

  updatePackings(event = null) {
    this.onValueChanged.emit(event);
  }

  //ExcelTemplate

  public elementSelectFunction(event) {
    this.elementSelected.emit(event);
  }

  public excelElementDrop(e) {
    this.excelElementDropped.emit(e);
  }

  public readOnlyForLinkedFields(field: string, system: string = '-1', element: string = '-1'): boolean {
    // Wenn dies ein vom Master vererbtes Feld ist, soll es ReadOnly sein:
    if (field != null) {
      var isLinked = this.model.isFieldLinked(field, system, element);
      if (isLinked && this.model.isChild != null && this.model.isChild) {
        // Für einen Master darf es nicht ReadOnly werden!!
        return true;
      }
    }

    //return this.readOnly(productId);

    return false;
  }

  public showClearButton(field: string): boolean {
    return !this.readOnlyForLinkedFields(field) && !this.templateView;
  }

  public hasMasterOrChildOrIsTranslated(): boolean {
    return this.model.hasMasterOrChild();
  }

  public isFieldLinked(field: string, system: string = '-1', element: string = '-1'): boolean {
    return this.model.isFieldLinked(field, system, element);
  }

  public toggleLinkedField(field: string, system: string = '-1', element: string = '-1', event = null) {
    var changed = this.model.toggleLinkedField(field, system, element);
    if (!changed) {
      return;
    }

    var isNowLinked = this.isFieldLinked(field, system, element);
    event.target.className = this.model.getClassForLinkedField(isNowLinked);

    if (this.model.isChild && isNowLinked) {
      event.forceReload = true;
    }

    // Etwas schmutzig, aber sonst können wir den Refresh am Tree nicht antriggern.
    //event.forceTreeRefresh = true;

    // SAVE
    this.update(event);
  }

  public getInitialClassForLinkedField(field: string, system: string = '-1', element: string = '-1'): string {
    var isNowLinked = this.isFieldLinked(field, system, element);
    return this.model.getClassForLinkedField(isNowLinked);
  }

  canView(name: string): boolean {
    return !this.isVirtualCatalog() && this.userManagement.canView(name);
  }
  readOnly(name: string): boolean {
    return this.isVirtualCatalog() || !this.userManagement.canEdit(name);
  }
 
}
